import { useCallback, useEffect, useState } from 'react';
import ServiceTemplate from '@/components/template/service/ServiceTemplate';
import { List, message } from 'antd';
import { Title } from '@/components/atoms';
import ServiceAccountItem from '@/components/organisms/service/ServiceAccountItem';
import { pcompany } from '@/proto/proto';
import { useSelector } from 'react-redux';
import { RootState } from '@/rootReducer';
import api from '@/api';
import PasswordChecker from '@/components/organisms/auth/PasswordChecker';

const ServiceManageAccountPage = () => {
  const { current: company } = useSelector((state: RootState) => state.company);

  const [data, setData] = useState<pcompany.IPbCompanyExternal[]>([]);

  const [isAllowed, setAllowed] = useState(false);
  const [error, setError] = useState();

  const fetch = useCallback(() => {
    api.get(`/company/${company.base?.id}/external/all`).then((response) => {
      setData(response.data.companyExternal);
    });
  }, [company]);

  const edit = useCallback(
    (external) => {
      api
        .post(`/company/${company.base?.id}/external`, 'pcompany.PbCompanyExternal', external)
        .then(() => {
          message.success('변경 성공');
          fetch();
        })
        .catch((reason) => {
          setError(reason);
        });
    },
    [company, fetch],
  );

  useEffect(() => {
    if (company) {
      fetch();
    }
  }, [company, fetch]);

  useEffect(() => {
    if (error) {
      message.error(error);
      setError(undefined);
    }
  }, [error]);

  return isAllowed ? (
    <ServiceTemplate>
      <Title>연동 계정 관리</Title>
      <List
        split
        dataSource={data}
        renderItem={(external: pcompany.IPbCompanyExternal) => {
          return (
            <ServiceAccountItem
              data={external}
              onClickSave={(userId, userPassword) => {
                edit({ ...external, userId, userPassword });
              }}
            />
          );
        }}
      />
    </ServiceTemplate>
  ) : (
    <PasswordChecker onPerformed={(allow) => setAllowed(allow)} />
  );
};

export default ServiceManageAccountPage;
